import React, { Component } from 'react';
import { signinUser, authError, fillSignInEmail } from '../../actions';
import { connect } from 'react-redux';
import { Form, FormGroup, FormControl, Button, Alert } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import './Signin.css';

class Signin extends Component {
  constructor(props) {
    super(props);

    this.state = {
      email: '',
      password: ''
    };
  }

  componentDidMount() {
    const { fillSignInEmail } = this.props.auth;
    if (fillSignInEmail) {
      this.setState({ email: fillSignInEmail }, () => {
        this.props.fillSignInEmail(null);
      });
    }
    this.props.authError('');
  }

  handleFormSubmit = (e) => {
    e.preventDefault();
    this.props.signinUser({ 
      email: this.state.email, 
      password: this.state.password, 
      history: this.props.history
    });
  }

  onInputChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  }

  renderAlert = () => {
    if (this.props.auth.errorMessage) {
      return (
        <Alert bsStyle="danger">
          <strong>Oops!</strong> {this.props.auth.errorMessage}
        </Alert>
      );
    }
  }
  
  render() {
    return (
      <div className="signin-container">
        {/* <div className="card" style={{ padding: 0}}>
          <div className="logo">
            <img src={require('../../logo.png')} alt="Logo" />
          </div>
        </div> */}
        <div className="card">
          <div className="header">Log In</div>
          <Form onSubmit={this.handleFormSubmit}>
            <FormGroup controlId="email">
              <FormControl 
                bsSize="large"
                type="email" 
                placeholder="Email Address" 
                value={this.state.email} 
                name="email" 
                required
                onChange={(e) => this.onInputChange(e)} />
            </FormGroup>
            <FormGroup controlId="password">
              <FormControl 
                bsSize="large"
                type="password" 
                placeholder="Password" 
                value={this.state.password} 
                name="password" 
                required
                onChange={(e) => this.onInputChange(e)} />
            </FormGroup>
            {this.renderAlert()}
            <Button 
              bsSize="large"
              className="btn-signin" 
              bsStyle="primary" 
              type="submit"
            >Log In</Button>
          </Form>
        </div>
        <p className="signup-link">Don't have an account? <Link to="/signup">Sign up!</Link></p>
      </div>
    );
  }
}

function mapStateToProps ({ auth, user }) {
  return {
    auth,
    user
  }
}

export default connect(mapStateToProps, { signinUser, authError, fillSignInEmail })(Signin);
